let taskHistoryDetailsCols = [
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Date'
    },
    {
        key: 'taskTypeId',
        display: 'Type Id'
    },
    {
        key: 'taskTypeLabel',
        display: 'Type Label'
    },
    {
        key: 'username',
        display: 'User'
    }
]

let taskHistoryCols = [
    {
        key: 'claimId',
        display: 'Claim Id'
    },
    {
        key: 'claimReference',
        display: 'Claim Reference'
    },
    {
        key: 'relatedReference',
        display: 'Related Reference'
    },
    {
        key: 'taskTypeId',
        display: 'Type Id'
    },
    {
        key: 'taskTypeLabel',
        display: 'Type Label'
    },
    {
        key: 'eventId',
        display: 'Event Id'
    },
    {
        key: 'eventName',
        display: 'Event Name'
    },
    {
        key: 'username',
        display: 'User'
    },
    {
        key: 'dateCreated',
        display: 'Date'
    }
]

export { taskHistoryDetailsCols, taskHistoryCols }